import styled from 'styled-components';
import Button from '@narvar/nth-button';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
  gap: 20px;
`;

export const CTAButton = styled.button`
  background-color: transparent;
  color: ${({ branding }) => branding.brand_call_to_action};
  display: inline-block;
  border: 0 none;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: underline;
`;

export const FormIntroWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const FormComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FormOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  gap: 20px;
  min-height: 100px;
`;

export const FormInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-direction: row;
  max-width: 420px;
  margin: auto;
`;

export const FormDescription = styled.p`
  line-height: 20px;
  font-weight: 400;
`;

export const Submit = styled(Button)`
  max-width: 100px;
  height: 50px;
`;
